var _defineProperty = require("/home/runner/work/agrpro.github.io/agrpro.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/runner/work/agrpro.github.io/agrpro.github.io/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.preToCodeBlock = function (preProps) {
  if ( // children is code element
  preProps.children && // code props
  preProps.children.props && // if children is actually a <code>
  preProps.children.props.mdxType === "code") {
    // we have a <pre><code> situation
    var _preProps$children$pr = preProps.children.props,
        codeString = _preProps$children$pr.children,
        _preProps$children$pr2 = _preProps$children$pr.className,
        className = _preProps$children$pr2 === void 0 ? "" : _preProps$children$pr2,
        props = _objectWithoutProperties(_preProps$children$pr, ["children", "className"]);

    var match = className.match(/language-([\0-\uFFFF]*)/);
    return _objectSpread({
      codeString: codeString.trim(),
      className: className,
      language: match != null ? match[1] : ""
    }, props);
  }

  return undefined;
};